import type { StatusMessageModule } from "@ebay/experience-types-ebay";

export interface Input {
  mapMessage: StatusMessageModule;
  "on-cta-click"?: () => void;
}

export default class extends Marko.Component<Input> {
  onCtaClick() {
    this.emit("cta-click");
  }
}
